export default "__VITE_ASSET__Cb8R3uCf__"